export default __webpack_public_path__ + "static/media/no-file.9a906e1c.jpg";